import { mapGetters } from 'vuex'

 
 const  Previewf=(file)=> {
    console.log(file.type,"jsUp上传前");
    let url=file.type
    //   window.open(url,'_blank');

    if (!url) {
      this.$message.error('上传失败')
      return
    }
    const type = url.split('/')[1]
    console.log(type,"split分割");
    // 判断文件类型
    if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type === 'pptx' || type === 'pdf' || type === 'txt') {
      console.log("是文件");
      // document.location.href = url
    } else {
      console.log("是图片");
      // this.$store.commit('CliCk_Menu',ssss)
      // this.t=false
      // window.open(url, 'hello')
 
    }

  }
  export{
    Previewf
  }